import pro1 from "../assets/Pro1.JPG";
import pro2 from "../assets/Pro2.JPG";
import pro3 from "../assets/Pro3.JPG";

const ProjectCardData = [
    {
        imgsrc : pro3,
        title : "Aruco Marker Detection using OpenCV",
        text : "Explore my ArUco marker detection project using OpenCV and Python. I've developed an efficient system to identify and label these markers in images. With applications in augmented reality and robotics, this project highlights my image-processing skills and practical programming solutions.",
        view : "https://github.com/AvaneeshPothuri/OpenCV-ArUco-Marker-Detection"
    },

    {
        imgsrc : pro2,
        title : "Hog-warts School Website (Bootstrp)",
        text : "Experience Hog-warts through my Bootstrap website. Explore the magical world from a captivating homepage to detailed sections like About Us, School Rules, and more. With responsive design, dive into the essence of each aspect. Unveil the enchantment with my web development touch.",
        view : "https://github.com/AvaneeshPothuri/Hog-warts"
    },

    {
        imgsrc : pro1,
        title : "Code Club Project: Embarking on the Coding Journey",
        text : "Embark on my Code Club adventure, a fusion of learning and creativity. Navigate through my web pages—from the inviting homepage to captivating sections like About and Members. Witness my initiation into web development as I collaborate, create, and embrace the coding spirit. This project marks the genesis of my coding odyssey—an invitation to explore the world of code and curiosity.",
        view : "https://github.com/AvaneeshPothuri/Code-Club"
    },
]

export default ProjectCardData;